<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<p style="padding-top:150px;"><strong>To grow up decent, our children need new clothing to present themself in school in proper neat! The sun has to shine for our children too. Amen</strong></p><br/>
<p>Sign painted by welfare mothers demonstrating outside Board of Education headquarters in Brooklyn, 8/28/1969</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?61e02f34